import React, {useEffect, useState} from 'react';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../../redux/selectors";

// providers

// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {ADD_STATE, REMOVE_STATE} from "../../../../redux/actions/generics/IndexedActions";

// components
import {DragDropList} from "../../../../components/draggableList/DragDropList";
import {benefitProvider} from "../../../../providers/benefitProvider";
import {promotionBenefitService} from "../../../../jwt/_services/relations/promotionBenefitService";
import BenefitItem from "./benefitRenderContent";
import {GenericContainer} from "../../../../components/containers/GenericContainer";


const BenefitSection = (props) => {
    const path = props.path + '/benefit';
    const [parent] = useState(props.parent || null);
    const componentState = useSelector(state => getStateByPath(state, path));
    const {listDomainObjects} = componentState?.data || [];
    const [benefits, setBenefits] = useState([]);
    const [promotionBenefits, setPromotionBenefits] = useState([]);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        benefitProvider.getOptions().then((options) => {
            setBenefits(options);
        });

        const dataRequest = {
            promotion: {id: parent?.id},
        };

        genericIndexedActions.search(path, promotionBenefitService, 0, 1000, dataRequest)
    }, []);

    useEffect(() => {
        if (benefits.length > 0 && listDomainObjects) {
            mapPromotionBenefits();
        }
    }, [benefits, listDomainObjects]);

    const mapPromotionBenefits = () => {
        // Mapea los beneficios que existen en listDomainObjects y los ordena por showOrder
        const existingPromotionBenefits = benefits
            .filter(benefit => listDomainObjects.some(domainObject => domainObject.benefit.id === benefit.id))
            .map(benefit => listDomainObjects.find(domainObject => domainObject.benefit.id === benefit.id))
            .sort((a, b) => a.showOrder - b.showOrder);

        // Mapea los beneficios que no existen en listDomainObjects
        const nonExistingPromotionBenefits = benefits
            .filter(benefit => !listDomainObjects.some(domainObject => domainObject.benefit.id === benefit.id))
            .map(benefit => ({ benefit }));

        // Combina los dos arrays para obtener el listado final
        const _promotionBenefits = [...existingPromotionBenefits, ...nonExistingPromotionBenefits];

        setPromotionBenefits(_promotionBenefits);
    }

    const addRemove = (promotionBenefit) => {
        // Validar si promotionBenefit es null o undefined
        if (!promotionBenefit?.id) {
            // Crear
            const dataRequest = {
                benefit: {id: promotionBenefit?.benefit.id},
                promotion: {id: parent?.id},
                showOrder: listDomainObjects.length + 1
            };

            console.log(dataRequest);

            // genericIndexedActions.save(path, promotionBenefitService, dataRequest)
        } else {
            // eliminar
            const dataRequest = {
                id: promotionBenefit.id,
            };

            console.log(dataRequest);

            // genericIndexedActions.delete(path, promotionBenefitService, promotionBenefit.id, dataRequest)
        }
    }

    const onReorder = (reorderProps) => {
        // Crear una copia de listDomainObjects para evitar mutaciones directas
        let updatedListDomainObjects = [...listDomainObjects];

        reorderProps.list.forEach((reorderedItem) => {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem.id) {
                // Buscar el ítem en listDomainObjects
                let domainObject = updatedListDomainObjects.find(domainObject => domainObject.id === reorderedItem.id);

                if (domainObject && domainObject.showOrder !== reorderedItem.showOrder) {
                    // Si el ítem existe y su showOrder ha cambiado, actualizarlo
                    let dataRequest = {
                        id: domainObject.id,
                        showOrder: reorderedItem.showOrder
                    };

                    console.log(dataRequest);

                    // genericIndexedActions.update(path, promotionBenefitService, domainObject.id, dataRequest)
                }
            }
        });
    }

    const renderContent = (promotionBenefit, index) => {
        const lbl = promotionBenefit?.benefit?.code || promotionBenefit?.benefit?.value
        return (
            <BenefitItem
                onClick={_ => addRemove(promotionBenefit)}
                label={ lbl?.toUpperCase().replace('_', ' ') }
                checked={ promotionBenefit?.id !== undefined }
                icon={promotionBenefit?.benefit?.icon}
                index={index + 1}
            />
        )
    }

    return (
        <GenericContainer
            titlle={'Beneficios'}
            listItems={promotionBenefits}
            renderContent={renderContent}
            onReorder={onReorder}
            orientationHV={'ruby-text-container'}
            fullheight={false}
        />
    );
}

const mapStateToProps = _ => ({})

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
})

export default connect(mapStateToProps, mapActionsToProps)(BenefitSection)
